export { QRCodeComponent } from './components';
export { QRCodeModule } from './angularx-qrcode.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angularx-qrcode/dist/index.js
// module id = 222
// module chunks = 0